import React, { createContext, useContext, useRef, ReactNode, useEffect } from 'react';
import { useApplication } from '@pixi/react';

interface CanvasKeyboardContextType {
  canvasRef: React.RefObject<HTMLCanvasElement | null>;
  setCanvas: (canvas: HTMLCanvasElement | null) => void;
}

const CanvasKeyboardContext = createContext<CanvasKeyboardContextType | null>(null);

interface CanvasKeyboardProviderProps {
  children: ReactNode;
}

export function CanvasKeyboardProvider({ children }: CanvasKeyboardProviderProps) {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const setCanvas = (canvas: HTMLCanvasElement | null) => {
    canvasRef.current = canvas;
  };

  const value = {
    canvasRef,
    setCanvas,
  };

  return (
    <CanvasKeyboardContext.Provider value={value}>
      {children}
    </CanvasKeyboardContext.Provider>
  );
}

export function useCanvasKeyboard() {
  const context = useContext(CanvasKeyboardContext);
  if (!context) {
    throw new Error('useCanvasKeyboard must be used within a CanvasKeyboardProvider');
  }
  return context;
}

// Component to register the Pixi canvas with the keyboard context
export function CanvasRegistrar() {
  const { app } = useApplication();
  const { setCanvas } = useCanvasKeyboard();

  useEffect(() => {
    if (app?.view) {
      // Make the canvas focusable and register it
      app.view.tabIndex = 0;
      setCanvas(app.view);
    }
  }, [app?.view, setCanvas]);

  return null; // This component doesn't render anything
}